import React, { useState } from 'react';
import { Box, Typography,Container } from '@mui/material';
import Carousel from 'react-material-ui-carousel'
import { Paper, CardMedia } from '@mui/material';
import ex_01 from '../Assets/example001.png';
import ex_02 from '../Assets/example002.png';
import ex_03 from '../Assets/example003.png';
import ex_04 from '../Assets/example004.png';
import logoReact from '../Assets/logo192.png';
import nodeLabel from '../Assets/Node_logo.png';
import logoCss from '../Assets/css_logo.png';
import logoMui from '../Assets/mui_logo2.png';
import stampUp from '../css/stampUp.module.css';
import running from '../css/running.module.css';
import postgre_logo from  '../Assets/Postgre_logo.svg';
import bootstrap_logo from  '../Assets/bootstrap.svg';
import useMediaQuery from '@mui/material/useMediaQuery';
import ModalMail from './ModalMail';
import logo_telegramm from '../Assets/telegram.png';
import logo_facebook from '../Assets/facebook.png';
import logo_viber from '../Assets/viber.png';
import cont from '../css/vibro.module.css';
import logoMail from '../Assets/message.png';
import swing from '../css/swing.module.css';
import Background from "../Components/Background";
import Header from "../Components/Header";
import Footer from "../Components/Footer";

function HomePage() {
  const [language,setLanguage]= useState();
  const [modal,setModal] = useState();
  const matches = useMediaQuery('(min-width:1000px)');

const example_img1 =[ex_01,ex_02,ex_03,ex_04];
const example_img =[{image:ex_01,title: language ? 'Интернет-магазин климатического оборудования: страница каталога.':'Online store of climate control equipment: catalog page.'},{image:ex_02,title: language  ?'Интернет-магазин климатического оборудования: "О нас"' : 'Online store of climate control equipment: page About'},{image:ex_03,title: language  ?'Сайт туристического агенства.': 'Travel agency website.'},{image:ex_04,title: language ? 'Сайт-портфолио.':'Portfolio website.'}];


function openModal(){
  setModal(true)
};
function closeModal(value){
  setModal(value)
};
function changeLanguage(value){
  setLanguage(value)
};

    return (
      <Container  sx={{backgroundColor:'#0F4CAE',minWidth:'100%',height:900 ,opacity:'0.9'}}>
   <Background/>
   <Header value={changeLanguage}/>
    <Box sx={{maxWidth:1900,marginLeft:'auto', marginRight:'auto',minHeight:'101vh'}}>

      <Box sx={{marginLeft:'auto', marginRight:'auto',display:'flex',flexDirection:'column',alignItems:'center',zIndex:-1}}>
        
        <Typography variant={matches ? 'h2' : 'h4'}sx={{marginTop:'20px',color:'white',textAlign:'center'}}>{language ? 'УНИКАЛЬНЫЕ РЕШЕНИЯ ДЛЯ ВАС'
             :'UNIQUE SOLUTIONS FOR YOU' }
        </Typography>
        <Box sx={{maxWidth:800}}>
        <Typography variant='h6'sx={{marginTop:'20px',color:'white',textAlign:'center'}}>{language  ? 'Привет. Меня зовут Андрей. Мне всегда нравилось воплощать идеи в реальность, поэтому я занялся разработкой веб-приложений. Сначала это было хобби, но со временем это стало моей любимой работой.'
                 :'Hello. My name is andrey. I have always liked bringing ideas to reality, so i got into web application development. It was a hobby at first, but over time it became my favorite job.' }
        </Typography>
        <Typography sx={{marginTop:'20px',color:'white',textAlign:'center'}} variant='h6'>{language  ? 'Мой опыт: помогу вам создать интернет-торговую площадку, электронный каталог вашей продукции, личный блог, чат, портфолио и другие полезные приложения.':'My experience: i will help you create an online trading platform, an electronic catalog of your products, a personal blog, chat, portfolio and other useful applications.' }
        </Typography>
        
        <Typography variant='h6' sx={{marginTop:'20px',color:'white',textAlign:'center'}} >{language  ? 'Мой стек: ':'My stack: ' }
          {'React JS, Next JS, Material UI, Bootstrap, Postgre_sql, Node JS, JS, TS, HTM, CSS, Apollo Client,Rest_api, Graph_ql, Strapi, Mob_x, Redux, Sequalize'}</Typography>
          
        
        </Box>
        </Box>
    
{matches ? <><Box sx={{display:'flex',justifyContent:'space-between',marginTop:8,marginLeft:10,marginRight:10, flexWrap:'wrap'}}>
<img src={bootstrap_logo} style={{width:'100px',height:'100px',borderRadius:'10px'}}/>
<Box><img src={nodeLabel} style={{width:'200px',height:'100px',borderRadius:'10px'}}/></Box>
       
       <Box ><img src={postgre_logo} style={{width:'100px',height:'100px',borderRadius:'10px'}}/></Box>
       <Box className={running.block}><img  src={logoReact} style={{width:'100px',height:'100px'}}/></Box>
       <Box ><img src={logoMui} style={{width:'100px',height:'100px',borderRadius:'10px'}}/></Box>
       <Box><img src={logoCss} style={{width:'300px',height:'100px'}}/></Box>
</Box> </> :<Box sx={{display:'flex', justifyContent:'center'}}>
       <Box ><img src={postgre_logo} style={{width:'100px',height:'100px',borderRadius:'10px'}}/></Box>
       <Box className={running.block}><img  src={logoReact} style={{width:'100px',height:'100px'}}/></Box>
       <Box ><img src={logoMui} style={{width:'100px',height:'100px',borderRadius:'10px'}}/></Box>
       </Box>} 
    <Box sx={{display:'flex',justifyContent:'center',marginTop:5}}>
        <Typography className={stampUp.type1} variant='h5' color='white'>{language  ? 'ПРИМЕРЫ МОИХ РАБОТ':'EXAMPLES OF MY WORK'}</Typography>
        
        </Box>
        <Box>
       {matches ? <Carousel   sx={{marginTop:5}} navButtonsAlwaysVisible>
            
            {example_img.map(item => <Paper  key={item.title} sx={{maxWidth: 1500 ,marginLeft:'auto', marginRight:'auto'}} >
         <Box sx={{display:'flex',background:'#346C9B',width:'100%', height:'50px',justifyContent:'center',alignItems:'center',borderRadius:1}}><Typography variant='h6'sx={{color:'white'}}>{item.title}</Typography></Box>
             <CardMedia
          
                    component="img"
                    
                    image={item.image}
                   
      // alt={data.data.Seo.alt ? data.data.Seo.alt : ''}
    />
             </Paper>) }
      
          </Carousel> : <Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}>{example_img.map(el =><Box> <Box sx={{background:'#346C9B',width:'100%', height:'50px',display:'flex',justifyContent:'center',alignItems:'center',borderRadius:1}}><Typography sx={{color:'white',margin:1}}>{el.title}</Typography></Box><img src={el.image} style={{width:'100%'}}/></Box>)}</Box>}
          </Box>
          <Box sx={matches ? {display:'flex',flexDirection:'column',position:'fixed', zIndex:'20',alignItems:'center',top:'200px'}:
    {display:'flex', zIndex:'20',justifyContent:'center'}}>
         

        <a href='https://t.me/Klimat1812'><img   src={logo_telegramm} alt="" style={{maxWidth:'50px',maxHeight:'50px',margin:'10px'}} /></a>
        <a href='viber://chat?number=380677051399'><img className={ cont.wibro } src={logo_viber} alt="" style={{maxWidth:'60px',maxHeight:'60px',margin:'10px'}} /></a>
        <a href='https://www.facebook.com/profile.php?id=100015060969349'><img src={logo_facebook} alt="" style={{maxWidth:'50px',maxHeight:'50px',margin:'10px'}} /></a>
        <a ><img onClick={openModal} className={swing.swing} src={logoMail} alt="" style={{maxWidth:'50px',maxHeight:'50px',margin:'10px'}} /></a>
        </Box>
          <ModalMail openMail={modal} closeMail={closeModal}/>
</Box>  
<Footer/>  
      </Container>
    );
  }
  
  export default HomePage;